/* eslint-disable no-param-reassign */
import { SystemFuncArgs } from '@brochington/ecstatic';
import { Components } from 'editor/components';
import Events from 'editor/components/Events';

export const addEventsComponents = [Events];

export function addEvents(args: SystemFuncArgs<Components>): void {
  // Add some very nice events here.
  // Question: What should cleanup look like?

  const { world, components } = args;
  const eventsComp = components.get(Events);

  if (!eventsComp.added) {
    eventsComp.onEventsAdd(world);
  }
}
